import React from 'react';
export function Problem() {
  return <section className="py-8 px-4 bg-soft-rose/50" data-id="element-184">
      <div className="max-w-4xl mx-auto space-y-8" data-id="element-185">
        {/* The Root Problem */}
        <div data-id="element-186">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-6" data-id="element-187">
            El verdadero problema no es lo que creés
          </h2>

          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-soft space-y-4 text-base" data-id="element-188">
            <p data-id="element-189">
              La mayoría de las mujeres piensan que su dolor es personal. Que es
              su culpa. Que si trabajaran más su "mentalidad" o fueran más
              disciplinadas, todo cambiaría.
            </p>
            <p data-id="element-190">Pero nadie te contó la verdad:</p>

            <div className="bg-soft-rose p-4 rounded-xl border-l-4 border-deep-rose my-4" data-id="element-191">
              <h3 className="text-lg md:text-xl font-bold text-warm-brown-dark" data-id="element-192">
                El 80% de los bloqueos emocionales, físicos y creativos de una
                mujer no nacen en ella. Nacen en su árbol.
              </h3>
            </div>

            <p data-id="element-193">
              Cuando tu abuela materna vivió una guerra, una hambruna o un
              abandono mientras gestaba a tu madre, esa señal de "el mundo es
              peligroso" se codificó químicamente en el ADN que eventualmente te
              formó a vos.
            </p>
            <p className="font-semibold text-lg text-center my-4" data-id="element-194">
              Eso no es metáfora. Eso es{' '}
              <span className="text-deep-rose" data-id="element-195">Epigenética</span>. Eso es{' '}
              <span className="text-deep-rose" data-id="element-196">ciencia</span>.
            </p>
            <p className="text-center italic text-warm-brown" data-id="element-197">
              Y tiene un nombre: <strong data-id="element-198">Memorias Celulares Ancestrales</strong>
              .
            </p>

            <ul className="space-y-3 mt-4" data-id="element-199">
              <li className="flex gap-3" data-id="element-200">
                <span className="text-deep-rose" data-id="element-201">❌</span> Por eso podés hacer
                todas las afirmaciones del mundo pero seguir saboteando tus
                relaciones.
              </li>
              <li className="flex gap-3" data-id="element-202">
                <span className="text-deep-rose" data-id="element-203">❌</span> Por eso podés saber
                intelectualmente que "merecés amor" pero seguir eligiendo
                migajas.
              </li>
              <li className="flex gap-3" data-id="element-204">
                <span className="text-deep-rose" data-id="element-205">❌</span> Por eso podés tener
                claridad mental pero seguir sintiendo el cuerpo tenso, bloqueado
                o desconectado.
              </li>
            </ul>

            <h4 className="text-xl font-bold text-center text-deep-rose mt-6" data-id="element-206">
              No es que estés rota. Es que nadie te enseñó a limpiar lo que
              heredaste.
            </h4>
          </div>
        </div>

        {/* Why Previous Failed */}
        <div data-id="element-207">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-6" data-id="element-208">
            Por qué todo lo que intentaste antes no llegó al fondo
          </h2>

          <div className="overflow-x-auto" data-id="element-209">
            <table className="w-full bg-white rounded-2xl shadow-soft overflow-hidden" data-id="element-210">
              <thead className="bg-warm-brown text-white" data-id="element-211">
                <tr data-id="element-212">
                  <th className="py-3 px-4 text-left font-semibold text-base" data-id="element-213">
                    Lo que intentaste
                  </th>
                  <th className="py-3 px-4 text-left font-semibold text-base" data-id="element-214">
                    Por qué no alcanzó
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-soft-rose" data-id="element-215">
                <tr className="hover:bg-soft-rose/30 transition-colors" data-id="element-216">
                  <td className="py-3 px-4 font-medium flex items-center gap-2" data-id="element-217">
                    🧠 Terapia convencional
                  </td>
                  <td className="py-3 px-4 text-warm-brown-dark text-sm" data-id="element-218">
                    Se queda en la mente. El trauma ancestral vive en el cuerpo.
                  </td>
                </tr>
                <tr className="hover:bg-soft-rose/30 transition-colors" data-id="element-219">
                  <td className="py-3 px-4 font-medium flex items-center gap-2" data-id="element-220">
                    📚 Libros de autoayuda
                  </td>
                  <td className="py-3 px-4 text-warm-brown-dark text-sm" data-id="element-221">
                    Dan información pero no integración somática ni ritual.
                  </td>
                </tr>
                <tr className="hover:bg-soft-rose/30 transition-colors" data-id="element-222">
                  <td className="py-3 px-4 font-medium flex items-center gap-2" data-id="element-223">
                    🧘 Meditación sin guía
                  </td>
                  <td className="py-3 px-4 text-warm-brown-dark text-sm" data-id="element-224">
                    Sin anclaje corporal, la mente vuelve al loop.
                  </td>
                </tr>
                <tr className="hover:bg-soft-rose/30 transition-colors" data-id="element-225">
                  <td className="py-3 px-4 font-medium flex items-center gap-2" data-id="element-226">
                    💬 Afirmaciones
                  </td>
                  <td className="py-3 px-4 text-warm-brown-dark text-sm" data-id="element-227">
                    No alcanzan si el sistema nervioso sigue en "modo peligro".
                  </td>
                </tr>
                <tr className="hover:bg-soft-rose/30 transition-colors" data-id="element-228">
                  <td className="py-3 px-4 font-medium flex items-center gap-2" data-id="element-229">
                    🌀 Sanar sola
                  </td>
                  <td className="py-3 px-4 text-warm-brown-dark text-sm" data-id="element-230">
                    Sin mapa del linaje, no sabés qué es tuyo y qué es heredado.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <h3 className="text-xl md:text-2xl font-bold text-center mt-6 text-deep-rose" data-id="element-231">
            El problema no eras vos. Era el método.
          </h3>
        </div>
      </div>
    </section>;
}